import { render, staticRenderFns } from "./SfAddress.vue?vue&type=template&id=28bee919"
import script from "./SfAddress.vue?vue&type=script&lang=js"
export * from "./SfAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  "3b315eb1"
  
)

export default component.exports